import * as React from "react";
import { AuthContext } from "../auth/Context";
import API from '../api/API';

function useAPI() {
  const {state, dispatch} = React.useContext(AuthContext);
  return new API(state, dispatch)
}

export default useAPI;